export const FETCH_PAID_ORDERS = 'FETCH_PAID_ORDERS'
export const ADD_ORDER = 'ADD_ORDER'
export const CONFIRM_ORDER = 'CONFIRM_ORDER'
